import { RestClientBuilder, RestClientError, RestClientHeaders, RestClientResponse } from '@sbercloud/ft-rest-client';
import qs from 'qs';

import { Fn } from '@/types/common';
import { always } from '@/utils/common';

import { isRequestCancelled } from './helpers';

const makeRestClientBuilder = (getRequiredHeaders?: Fn<void, RestClientHeaders>) =>
  new RestClientBuilder({
    getRequiredHeaders,
    onError(err, customOnErrorCallback) {
      if (err instanceof RestClientError) {
        if (isRequestCancelled(err)) {
          return;
        }

        customOnErrorCallback?.(err);
      }
    },
    onResponse(response: RestClientResponse<{ success?: boolean; log?: string }>, customOnResponse) {
      customOnResponse?.(response);
    },
    paramsSerializer: {
      serialize: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  });

export const makeQueryBuilder = (getRequiredHeaders?: Fn<void, RestClientHeaders>) =>
  Object.assign<RestClientBuilder, { abortAllRequests: Fn<void, void> }>(makeRestClientBuilder(getRequiredHeaders), {
    abortAllRequests: always<void>,
  });
